// Dubai - concealed ducted AC service (mount-type page).
const content = {
    slug: 'ducted-ac-service',
    title: (c) => `Ducted AC Service Dubai from ${c.money(c.tables.general[0].ducted)} | Concealed Units`,
    description: (c) =>
        `Service for concealed ducted AC units in Dubai apartments and villas: cleaning from ${c.money(c.tables.general[0].ducted)}, coil wash from ${c.money(c.tables.chemicalWash[0].ducted)}.`,
    eyebrow: 'Dubai · Ducted AC',
    h1: 'Ducted AC Service in Dubai',
    lead: (c) =>
        `Most Dubai apartments are cooled by a concealed ducted unit hidden above the false ceiling. Out of sight means out of mind - until it smells, leaks or stops cooling. Cleaning starts at ${c.money(c.tables.general[0].ducted)} per unit.`,
    image: 'blog/living/aircon/ceiling-cassette-aircon-servicing.jpg',
    imageAlt: 'Technician working on a ceiling-mounted AC unit',
    facts: ['Concealed units above the ceiling', 'Coil, blower and drain', 'Apartments and villas'],
    priceTitle: 'Ducted unit prices',
    priceIntro: 'Choose the service and the number of ducted units. Villas often have one unit per floor or zone.',
    panel: { type: 'servicing', services: ['general', 'chemicalWash', 'chemicalOverhaul'], defaultMount: 'Ducted' },
    sections: [
        {
            title: 'How a concealed ducted unit works',
            paragraphs: [
                'The indoor unit sits above the false ceiling, usually over the corridor, kitchen or a bathroom. It draws room air through a large return grille, passes it through a filter and across the coil, and pushes cool air through ducts to slot diffusers in each room.',
                'In buildings with their own systems, it is a split unit with an outdoor condenser on the roof or a plant deck. In district-cooled buildings it is a fan coil fed with chilled water. Both collect dust and need the same indoor cleaning.',
            ],
        },
        {
            title: 'Why ducted units need more attention than they get',
            tone: 'muted',
            cards: [
                { title: 'Hidden dirt', body: 'You never see the coil, so it goes uncleaned for years. The first sign is often a smell or a stained ceiling.' },
                { title: 'One unit, many rooms', body: 'A dirty unit cools the whole apartment badly, not just one room - and makes the bedrooms furthest from it the warmest.' },
                { title: 'Drain trays above your ceiling', body: 'A blocked tray overflows onto the ceiling board. Regular cleaning keeps the drain clear.' },
            ],
        },
        {
            title: 'What the technician needs',
            items: [
                'Access to the ceiling access panel - clear furniture below it.',
                'A ladder point near the panel; the technician brings their own ladder.',
                'Building permission if your tower requires contractor permits.',
                'The location of the return-air grille and filter.',
            ],
            columns: 2,
        },
    ],
    faqs: [
        {
            question: 'How much does ducted AC service cost in Dubai?',
            answer: (c) => `Cleaning costs ${c.money(c.tables.general[0].ducted)} for one ducted unit and ${c.money(c.tables.general[1].ducted)} for two. A coil chemical wash costs ${c.money(c.tables.chemicalWash[0].ducted)} per unit.`,
        },
        {
            question: 'Do you clean the ducts too?',
            answer: 'This service cleans the unit - filter, coil, blower and drain. Duct cleaning is a separate job and needed much less often. See our guide on duct cleaning vs coil cleaning.',
        },
        {
            question: 'There is no access panel - can you still service it?',
            answer: 'Usually there is one, sometimes hidden in a cupboard or bathroom ceiling. If there truly is none, the technician can advise on fitting one; we cannot cut the ceiling without your landlord\'s approval.',
        },
    ],
    schema: {
        name: 'Ducted AC Service in Dubai',
        serviceType: 'Ducted air conditioner servicing',
        offers: (c) => [
            { name: 'Ducted AC cleaning, 1 unit', price: c.tables.general[0].ducted },
            { name: 'Ducted AC cleaning, 2 units', price: c.tables.general[1].ducted },
            { name: 'Ducted coil chemical wash, 1 unit', price: c.tables.chemicalWash[0].ducted },
            { name: 'Ducted deep cleaning, 1 unit', price: c.tables.chemicalOverhaul[0].ducted },
        ],
    },
}

export default content
